"use strict";

exports.__esModule = true;
exports.registerIcon = registerIcon;
exports.registerAnimation = registerAnimation;
exports.registerLoader = registerLoader;
exports.connectInstance = connectInstance;
exports.disconnectInstance = disconnectInstance;
exports.getIcon = getIcon;
exports.getAnimation = getAnimation;
exports.loadIconData = loadIconData;
exports.loadIcon = loadIcon;
exports.loadLottieAnimation = loadLottieAnimation;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelperLoose(o) { var i = 0; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } i = o[Symbol.iterator](); return i.next.bind(i); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Store loadAnimation from Lottie.
 */
var LOTTIE_LOADER;
/**
 * Store all intances of Element.
 */

var INSTANCES = new Set();
/**
 * Store supported animations.
 */

var ANIMATIONS = new Map();
/**
 * Store icons in memory.
 */

var ICONS = new Map();
/**
 * List of promises for pending icons.
 */

var LOADING = new Map();
/**
 * Register new icon. Notify all Element instances about it.
 * @param name
 * @param animationClass
 */

function registerIcon(name, data) {
  ICONS.set(name, data);

  for (var _iterator = _createForOfIteratorHelperLoose(INSTANCES), _step; !(_step = _iterator()).done;) {
    var instance = _step.value;
    instance.notify(name, 'icon');
  }
}
/**
 * Register new animation. Notify all Element instances about it.
 * @param name
 * @param animationClass
 */


function registerAnimation(name, animationClass) {
  ANIMATIONS.set(name, animationClass);

  for (var _iterator2 = _createForOfIteratorHelperLoose(INSTANCES), _step2; !(_step2 = _iterator2()).done;) {
    var instance = _step2.value;
    instance.notify(name, 'animation');
  }
}
/**
 * Register lottie "loadAnimation" method.
 * @param loader
 */


function registerLoader(loader) {
  LOTTIE_LOADER = loader;
}
/**
 * Store element instance.
 * @param element
 */


function connectInstance(element) {
  INSTANCES.add(element);
}
/**
 * Remove element instance.
 * @param element
 */


function disconnectInstance(element) {
  INSTANCES.delete(element);
}
/**
 * Get stored icon.
 * @param name
 */


function getIcon(name) {
  return ICONS.get(name);
}
/**
 * Get stored animation.
 * @param name
 */


function getAnimation(name) {
  return ANIMATIONS.get(name);
}
/**
 * Fetch icon data from server.
 * @param url
 */


function loadIconData(_x) {
  return _loadIconData.apply(this, arguments);
}
/**
 * Load icon from url. This method tries to load single icon only once.
 * @param url
 */


function _loadIconData() {
  _loadIconData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadIconData.apply(this, arguments);
}

function loadIcon(_x2) {
  return _loadIcon.apply(this, arguments);
}
/**
 * Execute animation loading with provided "loadAnimation".
 * @param params
 */


function _loadIcon() {
  _loadIcon = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var current, promise, data;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!ICONS.has(url)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            current = LOADING.get(url);

            if (!current) {
              _context2.next = 7;
              break;
            }

            _context2.next = 6;
            return current;

          case 6:
            return _context2.abrupt("return");

          case 7:
            if (!(current === undefined)) {
              _context2.next = 15;
              break;
            }

            promise = loadIconData(url);
            LOADING.set(url, promise);
            _context2.next = 12;
            return promise;

          case 12:
            data = _context2.sent;
            LOADING.delete(url);
            ICONS.set(url, data);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadIcon.apply(this, arguments);
}

function loadLottieAnimation(params) {
  if (!LOTTIE_LOADER) {
    throw new Error('Unregistered Lottie.');
  }

  return LOTTIE_LOADER(params);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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